var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { transient } from "aurelia-dependency-injection";
import { CloneUtility } from "./clone";
import { Reflection } from "./reflection";
import { BindingEngine } from "aurelia-binding";
import * as Enumerable from "linq";
import { Guid } from "./guid";
var UnitOfWorkObserver = /** @class */ (function () {
    function UnitOfWorkObserver(bindingEngine, item, skipProperties, arraysChangesInterceptor) {
        if (skipProperties === void 0) { skipProperties = []; }
        if (arraysChangesInterceptor === void 0) { arraysChangesInterceptor = null; }
        this.bindingEngine = bindingEngine;
        this.item = item;
        this.arraysChangesInterceptor = arraysChangesInterceptor;
        this.unitOfWorks = {};
        this.subscriptions = [];
        this.paused = true;
        this.skipProperties = Enumerable.from(skipProperties);
        if (!Array.isArray(item)) {
            this.observe(item, this.unitOfWorks);
            if (item && this.skipProperties.all(function (x) { return x != "identifier"; })) {
                this.handleChange("identifier", item["identifier"], null, this.unitOfWorks);
            }
        }
        else {
            this.observeArray(item, this.unitOfWorks);
        }
    }
    UnitOfWorkObserver_1 = UnitOfWorkObserver;
    UnitOfWorkObserver.getTrackingInstance = function (bindingEngine, object, skipProperties, arraysChangesInterceptor) {
        if (skipProperties === void 0) { skipProperties = []; }
        if (arraysChangesInterceptor === void 0) { arraysChangesInterceptor = null; }
        var newInstance = new UnitOfWorkObserver_1(bindingEngine, object, skipProperties, arraysChangesInterceptor);
        newInstance.startTracking();
        return newInstance;
    };
    UnitOfWorkObserver.prototype.skipProperty = function (skipProperty) {
        var array = this.skipProperties.toArray();
        this.skipProperties = Enumerable.from(array.concat(skipProperty));
    };
    UnitOfWorkObserver.prototype.observeArray = function (array, unitOfWorks) {
        var e_1, _a;
        var _this = this;
        if (Array.isArray(array)) {
            var originalValue_1 = CloneUtility.clone(array);
            // this is for arrays
            unitOfWorks.Array = {
                isArray: true
            };
            var addedInitially = [];
            if (array["__array_observer__"]) {
                addedInitially = array["__array_observer__"].changeRecords[0].object;
            }
            var _loop_1 = function (arrayItem) {
                if (addedInitially.some(function (x) { return x == array[arrayItem]; })) {
                    return "continue";
                }
                var innerUnitOfWorks = {};
                var object = array[arrayItem];
                unitOfWorks.Array[array[arrayItem].id] = innerUnitOfWorks;
                if (Array.isArray(object)) {
                    this_1.observeArray(object, innerUnitOfWorks);
                }
                else {
                    this_1.observe(object, innerUnitOfWorks);
                }
            };
            var this_1 = this;
            try {
                for (var _b = __values(Object.keys(array)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var arrayItem = _c.value;
                    _loop_1(arrayItem);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.subscriptions.push(this.bindingEngine.collectionObserver(array)
                .subscribe(function (changedValues) {
                var e_2, _a;
                if (!_this.paused) {
                    try {
                        for (var changedValues_1 = __values(changedValues), changedValues_1_1 = changedValues_1.next(); !changedValues_1_1.done; changedValues_1_1 = changedValues_1.next()) {
                            var changedValue = changedValues_1_1.value;
                            _this.getUnitOfWorksForArrayChange(null, unitOfWorks.Array, array, originalValue_1, changedValue);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (changedValues_1_1 && !changedValues_1_1.done && (_a = changedValues_1.return)) _a.call(changedValues_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }));
        }
    };
    //here we will track the changes recursively
    UnitOfWorkObserver.prototype.observe = function (obj, unitOfWorks) {
        var e_3, _a;
        var _this = this;
        var properties = Reflection.getPropertiesOfObject(obj);
        var _loop_2 = function (propertyName) {
            var e_4, _b;
            if (this_2.skipProperties.any(function (x) { return x == propertyName; })) {
                return "continue";
            }
            var objectValue = obj[propertyName];
            var originalValue = CloneUtility.clone(objectValue);
            //if its an array then we have to go through all objects and create its own unitOfWork by calling observe
            if (Array.isArray(objectValue)) {
                // this is for arrays
                unitOfWorks[propertyName] = {
                    isArray: true
                };
                try {
                    for (var _c = (e_4 = void 0, __values(Object.keys(objectValue))), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var arrayItem = _d.value;
                        var innerUnitOfWorks = {};
                        var object = obj[propertyName][arrayItem];
                        unitOfWorks[propertyName][object.id] = innerUnitOfWorks;
                        this_2.observe(object, innerUnitOfWorks);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                this_2.subscriptions.push(this_2.bindingEngine.collectionObserver(obj[propertyName])
                    .subscribe(function (changedValues) {
                    var e_5, _a;
                    if (!_this.paused && !_this.skipProperties.any(function (x) { return x == propertyName; })) {
                        if (_this.skipProperties.all(function (x) { return x != "identifier"; })) {
                            _this.handleChange("identifier", obj["identifier"], null, unitOfWorks);
                        }
                        try {
                            for (var changedValues_2 = (e_5 = void 0, __values(changedValues)), changedValues_2_1 = changedValues_2.next(); !changedValues_2_1.done; changedValues_2_1 = changedValues_2.next()) {
                                var changedValue = changedValues_2_1.value;
                                _this
                                    .getUnitOfWorksForArrayChange(propertyName, unitOfWorks[propertyName], obj[propertyName], originalValue, changedValue);
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (changedValues_2_1 && !changedValues_2_1.done && (_a = changedValues_2.return)) _a.call(changedValues_2);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                    }
                }));
            }
            else {
                // we had to handle date scenaio since we do not want date to be considered as a complex object such as Auction or Individual etc
                if (!(objectValue instanceof Date) && objectValue instanceof Object) {
                    // this is for complex values
                    var innerUnitOfWorks = {};
                    unitOfWorks[propertyName] = innerUnitOfWorks;
                    this_2.observe(obj[propertyName], unitOfWorks[propertyName]);
                }
                else {
                    // this is for primitive values
                    this_2.subscriptions.push(this_2.bindingEngine.propertyObserver(obj, propertyName)
                        .subscribe(function (newValue, oldValue) {
                        if (_this.paused || _this.skipProperties.any(function (x) { return x == propertyName; })) {
                            return;
                        }
                        if (_this.skipProperties.all(function (x) { return x != "identifier"; })) {
                            _this.handleChange("identifier", obj["identifier"], null, unitOfWorks);
                        }
                        _this.handleChange(propertyName, newValue, originalValue, unitOfWorks);
                    }));
                }
            }
        };
        var this_2 = this;
        try {
            for (var properties_1 = __values(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
                var propertyName = properties_1_1.value;
                _loop_2(propertyName);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (properties_1_1 && !properties_1_1.done && (_a = properties_1.return)) _a.call(properties_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    UnitOfWorkObserver.prototype.getValue = function (item, property) {
        var props = property ? property.split(".") : [];
        if (props.length == 0) {
            return null;
        }
        if (props.length === 1) {
            return item ? item[property] : null;
        }
        var value = this.getValue(item[props[0]], property.substring(property.indexOf(".") + 1));
        return value;
    };
    UnitOfWorkObserver.prototype.setValue = function (item, property, valueToSet) {
        if (property) {
            var props = property.split(".");
            if (props.length === 1) {
                item[property] = valueToSet;
            }
            else {
                this.setValue(item[props[0]], property.substring(property.indexOf(".") + 1), valueToSet);
            }
        }
    };
    UnitOfWorkObserver.prototype.getUnitOfWorkAssociated = function (property, uow) {
        if (property) {
            var props = property.split(".");
            if (props.length === 1) {
                return uow;
            }
            var value = this.getUnitOfWorkAssociated(property.substring(property.indexOf(".") + 1), uow[props[0]].value ? uow[props[0]].value : uow[props[0]]);
            return value;
        }
        return null;
    };
    UnitOfWorkObserver.prototype.addChange = function (propertyName, newValue, oldValue) {
        if (propertyName) {
            if (typeof propertyName == "function") {
                propertyName = Reflection.getPropertyName(propertyName);
            }
            if (this.getValue(this.item, propertyName) != newValue) {
                this.setValue(this.item, propertyName, newValue);
            }
            var unitOfWorks = this.getUnitOfWorkAssociated(propertyName, this.unitOfWorks);
            if (propertyName) {
                var props = propertyName.split(".");
                this.handleChange(props[props.length - 1], newValue, oldValue, unitOfWorks);
            }
        }
    };
    UnitOfWorkObserver.prototype.handleChange = function (propertyName, newValue, oldValue, unitOfWorks) {
        var existing = unitOfWorks[propertyName];
        if (newValue == oldValue && !existing) {
            return;
        }
        if (existing) {
            if (newValue == existing.oldValue) {
                delete unitOfWorks[propertyName];
                return;
            }
            existing.value = newValue;
        }
        else {
            // non array items can only be modified
            unitOfWorks[propertyName] = {
                action: UnitOfWorkAction.Modified,
                oldValue: oldValue,
                value: newValue
            };
        }
    };
    UnitOfWorkObserver.prototype.dispose = function () {
        var e_6, _a;
        try {
            for (var _b = __values(this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscription = _c.value;
                if (subscription && subscription.dispose) {
                    subscription.dispose();
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
        this.stopTracking();
        this.unitOfWorks = {};
        this.subscriptions = [];
    };
    UnitOfWorkObserver.prototype.startTracking = function () {
        this.paused = false;
    };
    UnitOfWorkObserver.prototype.stopTracking = function () {
        this.paused = true;
    };
    UnitOfWorkObserver.prototype.clearChanges = function (item) {
        this.unitOfWorks = {};
    };
    UnitOfWorkObserver.prototype.getChanges = function () {
        return this.getChangesInternal(this.unitOfWorks);
    };
    Object.defineProperty(UnitOfWorkObserver.prototype, "getHasChanges", {
        get: function () {
            var hasChanges = false;
            if (this.unitOfWorks) {
                hasChanges = this.hasChangesInternal(this.unitOfWorks, false);
            }
            return hasChanges;
        },
        enumerable: false,
        configurable: true
    });
    UnitOfWorkObserver.prototype.hasChanges = function (skipIdentifiers) {
        if (skipIdentifiers === void 0) { skipIdentifiers = false; }
        var hasChanges = false;
        if (this.unitOfWorks) {
            hasChanges = this.hasChangesInternal(this.unitOfWorks, skipIdentifiers);
        }
        return hasChanges;
    };
    UnitOfWorkObserver.prototype.hasChangesInternal = function (uow, skipIdentifiers) {
        var e_7, _a, e_8, _b;
        var hasChanges = false;
        if (!uow) {
            return true;
        }
        try {
            for (var _c = __values(Object.keys(uow)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var key = _d.value;
                if (key == "identifier" && skipIdentifiers) {
                    continue;
                }
                var item = uow[key];
                var objUOW = item;
                var arrayUOW = item;
                var otherUOW = item;
                if (otherUOW && otherUOW.action > -1) {
                    hasChanges = true;
                }
                else if (arrayUOW && arrayUOW.isArray && Object.keys(objUOW).length > 1) {
                    try {
                        for (var _e = (e_8 = void 0, __values(Object.keys(arrayUOW))), _f = _e.next(); !_f.done; _f = _e.next()) { //when its an array we recurse into the individual unit of works
                            var item1 = _f.value;
                            if (item1 != "isArray") {
                                hasChanges = this.hasChangesInternal(arrayUOW[item1], skipIdentifiers);
                                if (hasChanges) {
                                    break;
                                }
                            }
                        }
                    }
                    catch (e_8_1) { e_8 = { error: e_8_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_8) throw e_8.error; }
                    }
                }
                else if (objUOW && Object.keys(objUOW).length > 0) {
                    hasChanges = this.hasChangesInternal(objUOW, skipIdentifiers);
                    if (hasChanges) {
                        break;
                    }
                }
                if (hasChanges) {
                    break;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return hasChanges;
    };
    UnitOfWorkObserver.prototype.getChangesInternal = function (uow) {
        var e_9, _a, e_10, _b;
        var changes = {};
        if (!uow) {
            return changes;
        }
        try {
            for (var _c = __values(Object.keys(uow)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var key = _d.value;
                var item = uow[key];
                var objUOW = item;
                var arrayUOW = item;
                var otherUOW = item;
                if (otherUOW && otherUOW.action > -1) {
                    changes[key] = uow[key];
                }
                else if (arrayUOW && arrayUOW.isArray && Object.keys(objUOW).length > 1) {
                    try {
                        for (var _e = (e_10 = void 0, __values(Object.keys(arrayUOW))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var item1 = _f.value;
                            if (item1 != "isArray") {
                                if (this.hasChangesInternal(arrayUOW[item1], false)) {
                                    //when it's an array we check for changes and add the changes to the dictionary of changes
                                    if (!changes[key]) {
                                        changes[key] = {
                                            isArray: true
                                        };
                                    }
                                    changes[key][item1] = this.getChangesInternal(arrayUOW[item1]);
                                }
                            }
                        }
                    }
                    catch (e_10_1) { e_10 = { error: e_10_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_10) throw e_10.error; }
                    }
                    //this is how we get changes for the complex object
                }
                else if (objUOW && Object.keys(objUOW).length > 0) {
                    if (this.hasChangesInternal(objUOW, false)) {
                        changes[key] = this.getChangesInternal(objUOW);
                    }
                }
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_9) throw e_9.error; }
        }
        return changes;
    };
    //this is to handle adding and removing in an array
    UnitOfWorkObserver.prototype.getUnitOfWorksForArrayChange = function (arrayName, unitOfWorks, originalObject, object, changedValues) {
        var e_11, _a, e_12, _b;
        if (changedValues && changedValues.addedCount > 0) {
            var addedItems = originalObject.slice(changedValues.index, changedValues.index + changedValues.addedCount);
            addedItems = this.arraysChangesInterceptor ? this.arraysChangesInterceptor(arrayName, addedItems, true) : addedItems;
            try {
                for (var addedItems_1 = __values(addedItems), addedItems_1_1 = addedItems_1.next(); !addedItems_1_1.done; addedItems_1_1 = addedItems_1.next()) {
                    var addedItem = addedItems_1_1.value;
                    var innerUnitOfWorks = {
                        "": {
                            action: UnitOfWorkAction.Added,
                            value: CloneUtility.clone(addedItem),
                            oldValue: null
                        }
                    };
                    var generateGuid = Guid.generateGuid();
                    unitOfWorks[generateGuid] = (innerUnitOfWorks);
                    addedItem.uow = generateGuid;
                    this.observe(addedItem, innerUnitOfWorks);
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (addedItems_1_1 && !addedItems_1_1.done && (_a = addedItems_1.return)) _a.call(addedItems_1);
                }
                finally { if (e_11) throw e_11.error; }
            }
        }
        if (changedValues && changedValues.removed && changedValues.removed.length > 0) {
            var removedItems = changedValues.removed;
            removedItems = this.arraysChangesInterceptor ? this.arraysChangesInterceptor(arrayName, removedItems, false) : removedItems;
            try {
                for (var removedItems_1 = __values(removedItems), removedItems_1_1 = removedItems_1.next(); !removedItems_1_1.done; removedItems_1_1 = removedItems_1.next()) {
                    var removedItem = removedItems_1_1.value;
                    if (removedItem.uow) {
                        delete unitOfWorks[removedItem.uow];
                    }
                    else if (removedItem.id > 0) {
                        var innerUnitOfWorks = {
                            "": {
                                action: UnitOfWorkAction.Removed,
                                value: removedItem,
                                oldValue: null
                            }
                        };
                        unitOfWorks[removedItem.id] = innerUnitOfWorks;
                    }
                }
            }
            catch (e_12_1) { e_12 = { error: e_12_1 }; }
            finally {
                try {
                    if (removedItems_1_1 && !removedItems_1_1.done && (_b = removedItems_1.return)) _b.call(removedItems_1);
                }
                finally { if (e_12) throw e_12.error; }
            }
        }
    };
    var UnitOfWorkObserver_1;
    UnitOfWorkObserver = UnitOfWorkObserver_1 = __decorate([
        transient(),
        __metadata("design:paramtypes", [BindingEngine, Object, Array, Function])
    ], UnitOfWorkObserver);
    return UnitOfWorkObserver;
}());
export { UnitOfWorkObserver };
var UnitOfWorkItem = /** @class */ (function () {
    function UnitOfWorkItem() {
    }
    return UnitOfWorkItem;
}());
export { UnitOfWorkItem };
export var UnitOfWorkAction;
(function (UnitOfWorkAction) {
    UnitOfWorkAction[UnitOfWorkAction["Unknown"] = -1] = "Unknown";
    UnitOfWorkAction[UnitOfWorkAction["Added"] = 0] = "Added";
    UnitOfWorkAction[UnitOfWorkAction["Removed"] = 1] = "Removed";
    UnitOfWorkAction[UnitOfWorkAction["Modified"] = 2] = "Modified";
})(UnitOfWorkAction || (UnitOfWorkAction = {}));
